export const getMessageCode = (t: (key: string) => string): Record<string, string> => ({
  REQUIRED_EMAIL: t('common.validateMessage.requiredEmail'),
  WRONG_FORMAT_EMAIL: t('common.validateMessage.wrongEmail'),
  REQUIRED_PASSWORD: t('common.validateMessage.requiredPassword'),
  REQUIRED_FULL_NAME: t('common.validateMessage.requiredFullName'),
  REQUIRED_DATE_TIME: t('common.validateMessage.requiredDateTime'),
  REQUIRED_LAST_NAME: t('common.validateMessage.requiredLastName'),
  REQUIRED_FIRST_NAME: t('common.validateMessage.requiredFirstName'),
  REQUIRED_PHONE_NUMBER: t('common.validateMessage.requiredPhoneNumber'),
  REQUIRED_DOB: t('common.validateMessage.requiredDob'),
  REQUIRED_ID: t('common.validateMessage.requiredId'),
  REQUIRED_NATIONALITY: t('common.validateMessage.requiredNationality'),
  REQUIRED_LEVEL: t('common.validateMessage.requiredLevel'),

  REQUIRED_OTP: t('common.validateMessage.requiredOtp'),
  REQUIRED_SERVICE_NAME: t('common.validateMessage.requiredServiceName'),
  REQUIRED_SERVICE_NAME_PRICE: t('common.validateMessage.requiredServiceNamePrice'),
  REQUIRED_REASON_FIX_ROOM: t('common.validateMessage.requiredReasonFixRoom'),
  REQUIRED_CUSTOMER: t('common.validateMessage.requiredCustomer'),
  REQUIRED_EXPENSE_TYPE: t('common.validateMessage.requiredExpenseType'),
  REQUIRED_AMOUNT: t('common.validateMessage.requiredAmount'),
  REQUIRED_TRAVEL_AGENCY_NAME: t('common.validateMessage.requiredTravelAgencyName'),
  REQUIRED_INVOICE_NAME: t('common.validateMessage.requiredInvoiceName'),
  REQUIRED_MARKET: t('common.validateMessage.requiredMarket'),
  REQUIRED_SOURCE: t('common.validateMessage.requiredSource'),

  REQUIRED_CURRENT_PASSWORD: t('common.validateMessage.requiredCurrentPassword'),
  REQUIRED_NEW_PASSWORD: t('common.validateMessage.requiredNewPassword'),
  REQUIRED_NEW_PASSWORD_MIN: t('common.validateMessage.requiredNewPasswordMin'),
  REQUIRED_CONFIRM_PASSWORD: t('common.validateMessage.requiredConfirmPassword'),
  PASSWORD_NOT_MATCH: t('common.validateMessage.passwordNotMatch'),

  INVALID_CREDS: t('common.validateMessage.invalidCreds'),
  REQUIRED_GROUP_NAME: t('common.validateMessage.requiredGroupName'),
  REQUIRED_TA_COMPANY: t('common.validateMessage.requiredTaCompany'),
  REQUIRED_ROOM_TYPE: t('common.validateMessage.requiredRoomType'),
  REQUIRED_NUMBER_ROOM: t('common.validateMessage.requiredNumberRoom'),
  REQUIRED_PAX: t('common.validateMessage.requiredPax'),
  REQUIRED_RATE_AMOUNT: t('common.validateMessage.requiredRateAmount'),

  REQUIRED_TRANSACTION_PAGE: t('common.validateMessage.requiredTransactionPage'),
  REQUIRED_TRANSACTION_DATE: t('common.validateMessage.requiredTransactionDate'),
  REQUIRED_TRANSACTION_TYPE: t('common.validateMessage.requiredTransactionType'),
  REQUIRED_ADDON_SERVICE_TAX: t('common.validateMessage.requiredAddonServiceTax'),

  REQUIRED_VAT_CODE: t('common.validateMessage.requiredVatCode'),
  REQUIRED_GUEST_NAME: t('common.validateMessage.requiredGuestName'),
  REQUIRED_COMPANY_INVOICE_PAGE: t('common.validateMessage.requiredCompanyInvoicePage'),
  REQUIRED_REFERENCE: t('common.validateMessage.requiredReference')
});
